<div class="flex flex-col h-full bg-p-content-background md:border-r border-p-content-border" *transloco="let t">
  @if (!hideLogo()) {
    <div class="p-6 border-b border-p-content-border flex justify-center h-(--sb-mobile-header-height)">
      <a [routerLink]="['/']" class="flex items-center justify-center w-full" (click)="notifyActionCompleted()">
        @if (collapsed()) {
          @if (isDarkMode()) {
            <img src="/assets/logo/Shine_small_dark.svg" class="h-8 max-w-full" alt="Shine StoreSync logo" />
          } @else {
            <img src="/assets/logo/Shine_small_light.svg" class="h-8 max-w-full" alt="Shine StoreSync logo" />
          }
        } @else {
          @if (isDarkMode()) {
            <img src="/assets/logo/Shine_StoreSync_dark.svg" class="h-11 max-w-full" alt="Shine StoreSync logo" />
          } @else {
            <img src="/assets/logo/Shine_StoreSync_light.svg" class="h-11 max-w-full" alt="Shine StoreSync logo" />
          }
        }
      </a>
    </div>
  }

  <div class="flex flex-col h-full overflow-hidden py-4">
    @if (!collapsed()) {
      <sb-search-bar class="px-4 pb-4" (searchResultSelected)="notifyActionCompleted()" />
      <div class="grow overflow-y-auto">
        <p-panelMenu [multiple]="true" [model]="sidePanelMenuItems()">
          <ng-template #item let-item>
            <a
              pButton
              text
              [severity]="item.active && item.active() ? 'primary' : 'secondary'"
              [routerLink]="getRouterLink(item)"
              class="justify-start! w-full"
              (click)="!item.items ? notifyActionCompleted() : null"
            >
              <fa-icon
                [icon]="[item.iconPrefix || 'fal', item.icon]"
                class="mr-3"
                [ngClass]="item.active && item.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
                [fixedWidth]="true"
              />
              <span class="text-ellipsis overflow-hidden text-nowrap">{{ item.label }}</span>

              @if (item.showBetaTag) {
                <p-tag [value]="t('general.beta')" />
              }

              @if (item.items) {
                <fa-icon
                  [icon]="['fal', 'chevron-down']"
                  class="ml-auto"
                  [ngClass]="item.active && item.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
                  [fixedWidth]="true"
                  [rotate]="item.expanded ? '180' : '0'"
                />
              }
            </a>
          </ng-template>
        </p-panelMenu>
      </div>
    } @else {
      <div class="flex flex-col gap-2 px-2 pb-4">
        @for (item of sidePanelMenuItems(); track item.id) {
          <div class="w-full relative group">
            <a
              pButton
              text
              [pTooltip]="item.label + (item.showBetaTag ? ' (Beta)' : '')"
              tooltipPosition="right"
              [severity]="item.active && item.active() ? 'primary' : 'secondary'"
              [routerLink]="getRouterLink(item)"
              (click)="handleCollapsedItemClick($event, item, item.items?.length ? menuPopup : undefined)"
              class="justify-center! w-full px-0!"
              style="padding-left: 0 !important; padding-right: 0 !important"
            >
              <fa-icon
                [icon]="[item.iconPrefix || 'fal', item.icon]"
                [ngClass]="item.active && item.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
                [fixedWidth]="true"
              />
            </a>

            <p-tieredMenu #menuPopup [popup]="true" [model]="item.items || []" appendTo="body" styleClass="w-[200px]">
              <ng-template pTemplate="item" let-subItem>
                <a
                  [routerLink]="getRouterLink(subItem)"
                  class="p-menuitem-link flex items-center px-4 py-2 hover:bg-p-background-focus-color w-full cursor-pointer"
                  (click)="handleCollapsedItemClick($event, subItem, undefined); menuPopup.toggle($event)"
                >
                  <fa-icon
                    [icon]="[subItem.iconPrefix || 'fal', subItem.icon]"
                    class="mr-3"
                    [ngClass]="subItem.active && subItem.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
                    [fixedWidth]="true"
                  />
                  <span [ngClass]="{ 'text-p-color-primary': subItem.active && subItem.active() }">{{
                    subItem.label
                  }}</span>
                </a>
              </ng-template>
            </p-tieredMenu>
          </div>
        }
      </div>
    }
  </div>

  <div class="p-2 border-t border-p-content-border flex flex-col gap-2">
    <p-overlaybadge severity="danger" value="!" badgeSize="small" [badgeDisabled]="isNonDefaultStoresErrorFree()">
      <button
        pButton
        type="button"
        text
        severity="secondary"
        class="justify-start! w-full"
        [pTooltip]="collapsed() ? (defaultStore()?.attributes?.name || t('sidebar.allStores') | middleEllipsis) : ''"
        tooltipPosition="right"
        (click)="toggleBusinessMenu($event)"
        appendTo="body"
        *transloco="let t"
      >
        <fa-icon
          [icon]="['fal', 'store']"
          class="text-p-muted-color"
          [ngClass]="collapsed() ? 'mx-auto' : 'mr-2'"
          [fixedWidth]="true"
        />
        @if (!collapsed()) {
          <span class="text-ellipsis overflow-hidden text-nowrap">
            {{ defaultStore()?.attributes?.name || t('sidebar.allStores') | middleEllipsis }}
          </span>
          <fa-icon [icon]="['far', 'angle-down']" class="text-p-muted-color ml-auto" [fixedWidth]="true" />
        }
      </button>
    </p-overlaybadge>
    <div class="flex items-center w-full px-2 py-1" [ngClass]="collapsed() ? 'flex-col gap-2' : 'justify-between'">
      @for (item of sidebarFooterMenubarItems(); track item.id) {
        <ng-container *ngTemplateOutlet="sideFooterItem; context: { item }" />
      }
    </div>
  </div>
</div>

<p-popover #notificationsPopover appendTo="body" (onShow)="markAllNotificationsAsSeen()">
  <div class="w-80" *transloco="let t">
    <div class="flex items-center justify-between p-4 border-b border-p-content-border">
      <h3 class="text-sm font-semibold">{{ t('sidebar.notifications') }}</h3>
    </div>
    <div class="max-h-96 overflow-y-auto">
      @if (filteredNotifications().length === 0) {
        <div class="flex items-center justify-center py-12 px-4">
          <span class="text-sm text-p-muted-color">{{ t('sidebar.noNotifications') }}</span>
        </div>
      }
      @for (notification of filteredNotifications(); track notification.id) {
        @let storeName = !activeStoreId() ? getStoreName(notification.attributes.store_id) : null;
        @let isUnread = unseenAtOpen().has(notification.id.toString());
        <div class="flex items-start gap-3 p-4 border-b border-p-content-border last:border-0">
          <div class="flex flex-col gap-1 min-w-0 flex-1">
            @if (storeName) {
              <span class="text-xs font-medium text-p-color-primary truncate">{{ storeName }}</span>
            }
            <span class="text-sm" [class.font-medium]="isUnread">{{ notification.attributes.key }}</span>
            <span class="text-xs text-p-muted-color">{{
              notification.attributes.created_at | date: 'd MMM yyyy, HH:mm'
            }}</span>
          </div>
          @if (isUnread) {
            <div class="w-2 h-2 rounded-full bg-primary-500 shrink-0 mt-1.5"></div>
          }
        </div>
      }
    </div>
  </div>
</p-popover>

<p-tieredMenu #accountMenu [popup]="true" [model]="accountMenuItems()"></p-tieredMenu>

<p-tieredMenu #businessMenu [popup]="true" appendTo="body" [model]="businessMenuItems()" [styleClass]="'w-[300px]'">
  <ng-template pTemplate="item" let-item>
    <a
      (click)="item.command ? item.command($event) : null"
      [routerLink]="getRouterLink(item)"
      class="p-menuitem-link flex justify-between pr-1! pl-3 w-full! cursor-pointer items-center h-10"
      [ngClass]="{ group: item.showSettingsButton }"
      (click)="notifyActionCompleted()"
      *transloco="let t"
    >
      <span
        class="text-ellipsis overflow-hidden text-nowrap"
        [ngClass]="{ 'text-p-color-primary': item.active && item.active() }"
      >
        {{ item.label }}
      </span>

      @if (item.showSettingsButton || item.showWarning) {
        <div class="flex items-center">
          @if (item.showWarning) {
            <p-badge
              severity="danger"
              value="!"
              badgeSize="small"
              [pTooltip]="t('dashboard.tooltips.integrationError')"
              [tooltipPosition]="'left'"
            />
          }
          @if (item.showSettingsButton) {
            <button
              pButton
              type="button"
              text
              size="small"
              class="min-w-0!"
              [pTooltip]="t('sidebar.settings')"
              tooltipPosition="left"
              (click)="
                $event.stopPropagation();
                item.settingsCommand && item.settingsCommand($event);
                toggleBusinessMenu($event)
              "
            >
              <fa-icon
                [icon]="['fal', 'gear-complex']"
                [fixedWidth]="true"
                class="text-p-muted-color opacity-0 group-hover:opacity-100"
              />
            </button>
          }
        </div>
      }

      @if (item.showAddIcon) {
        <fa-icon [icon]="['far', 'plus-circle']" [fixedWidth]="true" class="text-p-color mr-2.5" />
      }
    </a>
  </ng-template>
</p-tieredMenu>

<ng-template #sideFooterItem let-item="item">
  @let menuItem = toSidebarFooterMenuItem(item);
  @let badgeCount = menuItem?.id === 'notifications' ? unreadNotificationsCount() : (menuItem?.badgeCount ?? 0);
  @let badgeValue = badgeCount > 0 ? '' + badgeCount : '!';
  @let showBadge = menuItem?.showWarning === true || badgeCount > 0;
  <p-overlaybadge
    [badgeDisabled]="!showBadge"
    [value]="badgeValue"
    severity="danger"
    badgeSize="small"
    [ngClass]="menuItem.hiddenClass || ''"
  >
    @if (menuItem?.routerLink !== undefined) {
      <a
        pButton
        text
        [routerLink]="getRouterLink(menuItem)"
        [attr.disabled]="menuItem.disabled ? true : null"
        [class.p-disabled]="menuItem.disabled"
        [pTooltip]="menuItem.tooltip"
        [tooltipPosition]="menuItem.tooltipPosition || 'top'"
        (click)="menuItem.command ? menuItem.command({ originalEvent: $event }) : notifyActionCompleted()"
        [ariaLabel]="menuItem.tooltip || menuItem.label"
        class="px-3 w-full hover:bg-p-background-focus-color"
      >
        <fa-icon
          pButtonIcon
          [icon]="[menuItem.iconPrefix || 'fal', menuItem.icon]"
          [ngClass]="menuItem.active && menuItem.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
          [fixedWidth]="true"
        />
      </a>
    }
    @if (menuItem?.routerLink === undefined) {
      <p-button
        text
        [disabled]="menuItem.disabled"
        [pTooltip]="menuItem.tooltip"
        [tooltipPosition]="menuItem.tooltipPosition || 'top'"
        (click)="menuItem.command && menuItem.command({ originalEvent: $event })"
        [ariaLabel]="menuItem.tooltip || menuItem.label"
        styleClass="px-3 w-full hover:bg-p-background-focus-color "
      >
        <ng-template #icon>
          <fa-icon
            [icon]="[menuItem.iconPrefix || 'fal', menuItem.icon]"
            [ngClass]="menuItem.active && menuItem.active() ? 'text-p-color-primary' : 'text-p-muted-color'"
            [fixedWidth]="true"
          />
        </ng-template>
      </p-button>
    }
  </p-overlaybadge>
</ng-template>
